export const chargeServicesDrawer = {
  title: "Charges and services",
  closeAria: "Close",
  subtitle: {
    catalog: "Reusable catalog for your invoices",
    select: "Select the items you want to add",
  },
  searchPlaceholder: "Search service…",
  createService: "Create service",
  loading: "Loading services…",
  empty: "You don't have any services yet. Create your first one.",
  item: {
    vat: "VAT {vat}%",
    edit: "Edit",
    delete: "Delete",
  },
  footer: {
    selected: "{count} selected | {count} selected",
    createInvoice: "Create invoice with these",
    addToInvoice: "Add to invoice",
  },
  form: {
    editTitle: "Edit service",
    newTitle: "New service",
    subtitle: "Reusable item for your invoices",
    photoLabel: "Photo",
    optional: "optional",
    uploadPhoto: "Upload",
    nameLabel: "Name",
    namePlaceholder: "e.g. Final cleaning",
    categoryLabel: "Category",
    categoryPlaceholder: "e.g. Cleaning",
    priceLabel: "Price",
    vatLabel: "VAT",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Detail shown on the invoice",
    cancel: "Cancel",
    save: "Save changes",
    create: "Create service",
  },
  toasts: {
    loadError: "Couldn't load the services.",
    photoError: "Couldn't upload the photo.",
    updated: "Service updated.",
    created: "Service created.",
    saveError: "Couldn't save the service.",
    deleteError: "Couldn't delete it.",
  },
  confirmDelete: 'Delete "{name}" from the catalog?',
};
